import { render, staticRenderFns } from "./BotoesEdicao.vue?vue&type=template&id=62825765&"
import script from "./BotoesEdicao.vue?vue&type=script&lang=js&"
export * from "./BotoesEdicao.vue?vue&type=script&lang=js&"
import style0 from "./BotoesEdicao.vue?vue&type=style&index=0&id=62825765&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports